<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <case-form
      :onSubmit="onSubmit"
    ></case-form>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import CaseForm from './CaseForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { medicalRegistry } = services;
const { caseService } = medicalRegistry;

export default {
  name: 'case-create',
  components: {
    LandingCreate,
    CaseForm,
  },
  data: () => ({
    isLoading: false,
    content: {
      pageTitle: 'Case Create',
      enableBackButton: true,
    },
  }),
  methods: {
    async onSubmit(data) {
      try {
        await caseService.create({ caseNumber: data });

        this.$snackbar.showOk({ text: 'Successfully created Case number!' });
        this.$router.push({ name: 'case.list' });
      } catch (e) {
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
    },
  },
};
</script>
